import React from 'react';

/**
 * NisanIcon — stylised outline of a traditional Malay/Islamic gravestone (Batu Nisan / Kayu Nisan).
 * Drop-in replacement for lucide-react icons: accepts className + any SVG props.
 * Uses currentColor so it inherits text color classes.
 */
export const NisanIcon = ({ className = '', strokeWidth = 1.8, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
    {...props}
  >
    {/* Symmetric gravestone silhouette:
        - pointed onion-dome apex
        - flared shoulders
        - narrow waist (double curve)
        - widened footed base */}
    <path d="
      M 12 2
      C 13 3.5, 13.8 5, 14.5 6.3
      C 15.4 7.4, 16.4 8.2, 16.9 9
      C 17.3 9.6, 17 10.3, 16.3 10.9
      C 15.5 11.5, 14.7 12.1, 14.7 13
      C 14.7 13.9, 15.5 14.5, 16 15.2
      C 16.5 15.9, 16.7 16.7, 16.7 17.5
      L 16.7 19
      C 16.7 19.4, 17 19.7, 17.4 19.9
      L 18 20.2
      C 18.4 20.4, 18.5 20.8, 18.5 21.3
      L 18.5 22
      L 5.5 22
      L 5.5 21.3
      C 5.5 20.8, 5.6 20.4, 6 20.2
      L 6.6 19.9
      C 7 19.7, 7.3 19.4, 7.3 19
      L 7.3 17.5
      C 7.3 16.7, 7.5 15.9, 8 15.2
      C 8.5 14.5, 9.3 13.9, 9.3 13
      C 9.3 12.1, 8.5 11.5, 7.7 10.9
      C 7 10.3, 6.7 9.6, 7.1 9
      C 7.6 8.2, 8.6 7.4, 9.5 6.3
      C 10.2 5, 11 3.5, 12 2
      Z
    " />
  </svg>
);

export default NisanIcon;
